import * as React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { IMySettings } from './IMySettings';
import { useTheme } from '../../context/ThemeContext';

export function SettingsPanel(props: any) {
  const [loading, setLoading] = React.useState(false);
  const [enableOnBehalfOf, setEnableOnBehalfOf] = React.useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  const onClose = React.useCallback(() => {
    props.onSettingsClosed();
  }, [props]);

  const onSave = React.useCallback(() => {
    const settings: IMySettings = {
      enableOnBehalfOf,
    };
    props.onSettingsSaved(settings);
  }, [props, enableOnBehalfOf]);

  React.useEffect(() => {
    setLoading(false);
    setEnableOnBehalfOf(props.settings.enableOnBehalfOf);
  }, [props]);

  return (
    <Sheet open={true} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="right" className="w-[400px] flex flex-col gap-4" style={{ top: '70px', height: 'calc(100vh - 70px)' }}>
        <SheetHeader>
          <SheetTitle>Settings</SheetTitle>
        </SheetHeader>

        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary" />
            Loading settings...
          </div>
        )}

        {/* Change Persona toggle */}
        {props.canImpersonate && 
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-3">
              <Switch
                id="onBehalfOf"
                checked={enableOnBehalfOf}
                onCheckedChange={setEnableOnBehalfOf}
              />
              <Label htmlFor="onBehalfOf">Change Persona</Label>
            </div>
          </div>
        }
        {/* Theme toggle */}
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-3">
            <span className="text-sm mt-[1.2rem]">Light</span>
            <div className="flex flex-col items-center gap-1">
              <Label className="text-sm">Theme</Label>
              <Switch
                id="darkMode"
                checked={isDarkMode}
                onCheckedChange={() => toggleTheme()}
              />
            </div>
            <span className="text-sm mt-[1.2rem]">Dark</span>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex gap-3 mt-4">
          <Button onClick={onSave}>OK</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
